import axios from 'axios';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IAppState, IMenuItem, initialMenu } from '../../interface/AppInterface';
// import Vitallogo from '../../assets/images/vitals/logo.svg';
import { endpoints } from '../../utils/URL';
import { addToast } from '../../utils/toastNotifications';
import { AppContext } from '../../context/AppContext';
import { formatDate } from '../../utils/dateTimeUtils';

const Menu = () => {
  const [menuItem, setMenuItem] = useState<IMenuItem>(initialMenu);
  const { appState, dispatch }: { appState: IAppState; dispatch: any } = useContext(AppContext);
  const pharmacyId: number = appState.pharmacyId;

  //get menu items
  const getMenu = useCallback(async () => {
    if (pharmacyId === 0) {
      dispatch({
        type: 'LOG_OUT',
      });
      return;
    }

    try {
      const url = `${endpoints.auth.mainUrl}/${pharmacyId}/menu`;
      const response = await axios.get(url);

      setMenuItem(response.data);
      dispatch({
        type: 'SET_MENU_ITEMS',
        payload: response.data,
      });
    } catch (error) {
      addToast('An error occured', 'error');
    }
  }, [pharmacyId, dispatch]);

  useEffect(() => {
    getMenu();
  }, [getMenu]);

  return (
    <div className='container'>
      {/* <PageTour
        steps={menuTourSteps}
        page='menu'
        run={localStorage.getItem('menuTour') === 'completed' ? false : true}
      /> */}
      <main style={{ marginTop: '15px' }}>
        <section className='container expire text-end'>
          <div className='row justify-content-center'>
            <div className='col-sm-10'>
              <div className='row justify-space-between align-items-middle'>
                <div className='col-sm-6 text-start'>
                  <Link
                    to={'/press'}
                    className='card card-hover d-inline-block px-3 py-2 press-campaign-link'
                  >
                    Press Campaign
                    {/* <img src={Vitallogo} alt='vital-logo' className='img-fluid' /> */}
                  </Link>
                </div>
                <div className='col-sm-6'>
                  <span className='expiry'>
                    <Link to='/entry'>
                      <i className='bi bi-clock'></i> Expiry:
                      <span
                        className={
                          new Date(menuItem.expiryDate).getTime() > new Date().getTime()
                            ? 'ms-1 text-success'
                            : 'ms-1 text-danger'
                        }
                      >
                        {formatDate(menuItem.expiryDate)}
                      </span>
                    </Link>
                  </span>
                  <span className='ms-4 smsCredits'>
                    <Link to='/entry'>
                      <i className='bi bi-cash mx-1'></i>SMS Credit:
                      <span
                        className={
                          menuItem.smsUnits < 10 ? 'ms-1 text-danger' : 'ms-1 text-success'
                        }
                      >
                        {menuItem.smsUnits.toLocaleString()}
                      </span>
                    </Link>
                  </span>
                  <span className='ms-4 tasks'>
                    {/* <button type='button' className='btn btn-primary'>
                      Notifications <span className='badge text-bg-secondary'>4</span>
                    </button> */}
                    {/* <Link to='/notifications'>
                      <span className='bi bi-bell mx-1 position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'>
                        {menuItem.notificationCount}
                      </span>
                    </Link> */}
                    <Link to='/notifications' className='position-relative bi bi-bell mx-1'>
                      <span className='fs-10 position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger'>
                        {menuItem.notificationCount > 99 ? '99+' : menuItem.notificationCount}
                        {/* <span className='visually-hidden'>unread messages</span> */}
                      </span>
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <span className='ms-4 topup'>
            <Link to='/entry'>
              <button className='btn btn-primary'>Top Up</button>
            </Link>
          </span> */}
        </section>

        <section className='container'>
          <div className='row justify-content-center'>
            <div className='col-sm-10'>
              <div className='row'>
                <div className='col-sm-6 col-md-3 col-6 viewPatients'>
                  <Link to='/patients' className='single-tab dashboard-tabs'>
                    <span className='ticker' id='ptCount'>
                      {menuItem.patientCount}
                    </span>
                    <div className='inner-tab'>
                      <img
                        src={require('../../assets/images/patients.svg').default}
                        alt='patient'
                        className='d-none d-sm-inline'
                      />
                      <p>View Patients</p>
                    </div>
                  </Link>
                </div>

                <div className='col-sm-6 col-md-3 col-6 sendMessages'>
                  <Link to='/messaging' className='single-tab dashboard-tabs'>
                    <span className='ticker' id='msgCount'>
                      {menuItem.messageCount}
                    </span>
                    <div className='inner-tab'>
                      <img
                        src={require('../../assets/images/chat.svg').default}
                        alt='chat'
                        className='d-none d-sm-inline'
                      />
                      <p>Send Messages</p>
                    </div>
                  </Link>
                </div>

                <div className='col-sm-6 col-md-3 col-6 viewRefills'>
                  <Link to='/refills' className='single-tab dashboard-tabs'>
                    <span className='ticker' id='refCount'>
                      {menuItem.refillCount}
                    </span>
                    <div className='inner-tab'>
                      <img
                        src={require('../../assets/images/vitamins.svg').default}
                        alt='refills'
                        className='d-none d-sm-inline'
                      />
                      <p>View Refills</p>
                    </div>
                  </Link>
                </div>

                <div className='col-sm-6 col-md-3 col-6 fulfilments'>
                  <Link to='/fulfilments' className='single-tab dashboard-tabs'>
                    <span className='ticker' id='notifCount'>
                      0{/* {menuItem.notificationCount} */}
                    </span>
                    <div className='inner-tab'>
                      <img
                        src={require('../../assets/images/tasks.svg').default}
                        alt='notifications'
                        className='d-none d-sm-inline'
                      />
                      <p>Fulfilments</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Menu;
